var React = require('react');

function IcnPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.331 14.644l-13.794-13.831 17.55 10.075zM2.938 0c-0.813 0.425-1.356 1.2-1.356 2.206v27.581c0 1.006 0.544 1.781 1.356 2.206l16.038-16zM29.512 14.1l-3.681-2.131-4.106 4.031 4.106 4.031 3.756-2.131c1.125-0.893 1.125-2.906-0.075-3.8zM6.538 31.188l17.55-10.075-3.756-3.756z"}));
}

IcnPlay.defaultProps = {"fill":"#000000","width":"800px","height":"800px","viewBox":"0 0 32 32"};

module.exports = IcnPlay;

IcnPlay.default = IcnPlay;
